import { Context } from "urql";
import Cookies from "js-cookie";
import { publicConfig } from "@lululemon/ecom-core";
import { setSkus } from "@lululemon/ecom-common/src/store/actions/skus";
import { setSizeGuide } from "@lululemon/ecom-common/src/store/actions/size-guides";

// 1) get product details for the size guide
// 2) get all skus for product (same query instead of the other sku query)
const productDetailsQuery = `
  query WishlistPdpQuery($category: String!, $unifiedId: String!, $forcePcm: Boolean!, $productId: String, $locale: String) {
    productDetailPage(category: $category, unifiedId: $unifiedId, forcePcm: $forcePcm, id: $productId, locale: $locale) {
      sizeGuide {
        url
        category
      }
      productSummary {
        productGender
        divisionId
      }
      productCarousel {
        imageInfo
        color {
          code
        }
        modelInfo {
          description
          modelIsWearing {
            productName
          }
        }
      }
      skus {
        id
        size
        inseam
        available
        color {
          code
          name
        }
        styleId
      }
    }
  }
`;

const fetchProductDetails = async ({
  color,
  productId,
  category,
  unifiedId,
  graphqlClient,
  dispatch,
  locale,
}) => {
  const apiHost = `${publicConfig?.apiHost}`;
  const KIWI_PATH = "/cne/graphql";
  Context.url = `${apiHost}${KIWI_PATH}`;

  const forcePcm = Cookies.get("lll-pcm-gate-wl") == 1 || false;

  const { data, error } = await graphqlClient
    .query(
      productDetailsQuery,
      { productId, category, unifiedId, locale, forcePcm },
      Context
    )
    .toPromise();

  if (error) {
    throw error;
  }

  const {
    productDetailPage: {
      sizeGuide = {},
      skus = [],
      productSummary = {},
      productCarousel = [],
    },
  } = data || {};

  const { productGender, divisionId } = productSummary;

  const selectedSwatch = productCarousel.find((pc) => {
    if (pc?.color?.code === color) {
      return pc;
    }
  });

  const { modelInfo = {}, imageInfo = [] } = selectedSwatch || {};
  const { description } = modelInfo;
  const result = {
    sizeGuide: {
      ...sizeGuide,
      productGender,
      productImage: imageInfo?.[0],
      divisionId,
      modelDescription: description,
    },
  };
  dispatch(setSizeGuide(productId, result.sizeGuide));
  dispatch(setSkus(productId, skus || []));
  return { ...result, skus };
};

export default fetchProductDetails;
